import { render } from "./FamilyPlan.vue?vue&type=template&id=6aaddb59&scoped=true&ts=true"
import script from "./FamilyPlan.vue?vue&type=script&lang=ts"
export * from "./FamilyPlan.vue?vue&type=script&lang=ts"

import "./FamilyPlan.vue?vue&type=style&index=0&id=6aaddb59&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aaddb59"]])

export default __exports__